<style lang="scss" src='./Support.scss' scoped></style>
<template src="./Support.html"></template>

<script>

export default {
  name: 'Support',
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  methods: {
    
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Support");
      this.$analytics.logEvent("web_support");
    }
  },
};

</script>
